/**
 * External dependencies
 */
import {
	ControlSeparator,
	DesignControl,
	IconControl,
	BackgroundSettings,
	URLInputControl
} from '~cartzillagb/components'

/**
 * Internal dependencies
 */
import ImageDesignBasic from './images/basic.png'
import ImageDesignGhost from './images/ghost.png'

/**
 * WordPress dependencies
 */
import {
	SelectControl,
	ToggleControl,
} from '@wordpress/components'
import {
	__,
} from '@wordpress/i18n'
import { applyFilters } from '@wordpress/hooks'
import { Fragment } from '@wordpress/element'
import { i18n } from 'cartzillagb'

const ButtonControls = props => {
	const design = props.design ? props.design : 'solid'
	const size = props.size ? props.size : 'default'
	const animation = props.animation ? props.animation : 'none'
	const delay = props.delay ? props.delay : 'none'
	const shape = props.shape ? props.shape : ''

	return (
		<Fragment>
				{ props.onChangeUrl && (
					<URLInputControl
						label={ __( 'Link / URL', i18n ) }
						value={ props.url }
						onChange={ props.onChangeUrl }
						placeholder="http://"
					/>
				) }
				{ props.onChangeUrl && <ControlSeparator /> }
					
				{ props.onChangeDesign && (
					<DesignControl
						label={ __( 'Design', i18n ) }
						selected={ design }
						options={ [
							{
								label: __( 'Solid', i18n ), value: 'solid', image: ImageDesignBasic,
							},
							{
								label: __( 'Outline', i18n ), value: 'outline', image: ImageDesignGhost,
							},
							...applyFilters( 'cartzillagb.button.edit.layouts', [] ),
						] }
						onChange={ props.onChangeDesign }
					/>
				) }

				<ControlSeparator />

				{ props.onChangeAnimation &&
					<SelectControl
						label={ __( 'Button Animation' ) }
						value={ animation }
						options={ [
							{ label: __('None', 'cartzilla', i18n ), value: 'none' },
							{ label: __('From Left', 'cartzilla', i18n ), value: 'from-left' },
							{ label: __('From Right', 'cartzilla', i18n ), value: 'from-right' },
							{ label: __('From Top', 'cartzilla', i18n ), value: 'from-top' },
							{ label: __('From Bottom', 'cartzilla', i18n ), value: 'from-bottom' },
							{ label: __('Scale Up', 'cartzilla', i18n ), value: 'scale-up' },
						] }
						onChange={ props.onChangeAnimation }
					/>
				}

				{ props.onChangeDelay &&
					<SelectControl
						label={ __( 'Button Delay' ) }
						value={ delay }
						options={ [
							{ label: __('None', 'cartzilla', i18n ), value: 'none' },
							{ label: __('Delay-1', 'cartzilla', i18n ), value: 'delay-1' },
							{ label: __('Delay-2', 'cartzilla', i18n ), value: 'delay-2' },
							{ label: __('Delay-3', 'cartzilla', i18n ), value: 'delay-3' },
							{ label: __('Delay-4', 'cartzilla', i18n ), value: 'delay-4' },
						] }
						onChange={ props.onChangeDelay }
					/>
				}

				<ControlSeparator />

				{ props.onChangeSize &&
					<SelectControl
						label={ __( 'Button Size', i18n ) }
						value={ size }
						options={ [
							{ value: 'lg', label: __( 'Large', i18n ) },
							{ value: 'default', label: __( 'Default', i18n ) },
							{ value: 'sm', label: __( 'Small', i18n ) },
							{ value: 'block', label: __( 'Block', i18n ) },
						] }
						onChange={ props.onChangeSize }
						className="czgb--help-tip-button-size"
					/>
				}

				{ props.onChangeShape &&
					<SelectControl
						label={ __( 'Button Shape', i18n ) }
						value={ shape }
						options={ [
							{ value: 'default', label: __( 'Default', i18n ) },
							{ value: 'pill', label: __( 'Pill', i18n ) },
							{ value: 'square', label: __( 'Square', i18n ) },
						] }
						onChange={ props.onChangeShape }
						className="czgb--help-tip-button-shape"
					/>
				}

				{ props.onChangeShadow && ( design === 'solid' ) && (
					<ToggleControl
						label={ __( 'Enable Shadow', i18n ) }
						checked={ props.shadow }
						onChange={ props.onChangeShadow }
					/>
				) }

				<ControlSeparator />

				{ props.onChangeBackgroundColor && (
					<BackgroundSettings 
						background={ props.backgroundColor }
						onChangeBackground={ props.onChangeBackgroundColor }
						softBackground={ false }
						prefix=''
					/>
				) }

				<ControlSeparator />

				{ props.onChangeIcon &&
					<IconControl
						label={ __( 'Icon', i18n ) }
						value={ props.icon }
						onChange={ props.onChangeIcon }
					/>
				}
				{ props.onChangeButtonIcon && (
					<ToggleControl
						label={ __( 'Is Icon Button ?', i18n ) }
						checked={ props.buttonIcon }
						onChange={ props.onChangeButtonIcon }
					/>
				) }

				{ props.onChangeiconAfterText && (
					<ToggleControl
						label={ __( 'Icon After Text ?', i18n ) }
						checked={ props.iconAfterText }
						onChange={ props.onChangeiconAfterText }
					/>
				) }
		</Fragment>
	)
}

ButtonControls.defaultProps = {
	showUrl: true,
	attrNameTemplate: '%s',
	setAttributes: () => {},
	blockAttributes: {},

	design: '',
	onChangeDesign: () => {},

	url: '',
	newTab: '',
	noFollow: '',
	onChangeUrl: () => {},
	onChangeNewTab: () => {},
	onChangeNoFollow: () => {},
	
	buttonIcon: '',
	shadow: '',
	onChangeButtonIcon: () => {},
	onChangeShadow: () => {},

	iconAfterText: '',
	onChangeiconAfterText: () => {},

	size: '',
	onChangeSize: () => {},

	animation: '',
	onChangeAnimation: () => {},

	delay: '',
	onChangeDelay: () => {},

	shape: '',
	onChangeShape: () => {},

	backgroundColorType: '',
	backgroundColor: '',
	onChangeBackgroundColorType: () => {},
	onChangeBackgroundColor: () => {},

	icon: '',
	onChangeIcon: () => {},

	// Used by social icon buttons.
	useSocialColors: true,
	onChangeUseSocialColors: null,
}

export default ButtonControls
